import { render } from "./Selectize.vue?vue&type=template&id=d5846e68&bindings={\"modelValue\":\"props\",\"settings\":\"props\",\"disabled\":\"props\",\"options\":\"data\",\"createdOptions\":\"data\",\"createdSettings\":\"data\",\"toggleDisabled\":\"options\",\"makeOptions\":\"options\",\"setValue\":\"options\"}"
import script from "./Selectize.vue?vue&type=script&lang=js"
export * from "./Selectize.vue?vue&type=script&lang=js"
script.render = render

export default script